export default {
    props: {
        transportDiscover: {
            type: Object | String | Function,
            kComposite: 'transport.discover'
        }, 
        transportConnectionCatalog: {
            type: String,
            kComposite: 'transport.connection.catalog'
        }, 
        transportConnectionCube: {
            type: String,
            kComposite: 'transport.connection.cube'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoPivotDataSource/Transport.js